import InAppMessage from "./in-app-message.js";
export default class HtmlMessage extends InAppMessage {
  constructor(i, o, e, r, d, t, s, v, n, u, a) {
    super(
      i,
      void 0,
      void 0,
      o,
      e,
      void 0,
      void 0,
      void 0,
      (r = r || InAppMessage.DismissType.MANUAL),
      d,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      void 0,
      t,
      s,
      void 0,
      void 0,
      void 0,
      v,
      void 0,
      void 0,
      void 0,
      n,
      u,
    ),
      (this.messageFields = a),
      (this.messageFields = a);
  }
  io() {
    return !1;
  }
  p(i) {
    if (this.Pe === InAppMessage.qe.ln) {
      if (this.do) return !1;
      this.do = !0;
    }
    return this.Et.Dt(i), !0;
  }
  tt() {
    const i = super.tt(HtmlMessage.et);
    return (i[InAppMessage.it.vo] = this.messageFields), i;
  }
  static an(i) {
    return new HtmlMessage(
      i[InAppMessage.it.ea],
      i[InAppMessage.it.jt],
      i[InAppMessage.it.sa],
      i[InAppMessage.it.oa],
      i[InAppMessage.it.pa],
      i[InAppMessage.it.ga],
      i[InAppMessage.it.ja],
      i[InAppMessage.it.va],
      i[InAppMessage.it.ba],
      i[InAppMessage.it.CSS],
      i[InAppMessage.it.vo],
    );
  }
}
HtmlMessage.et = InAppMessage.qe.ln;
